import RulesHelp from "./../shared/RulesHelp.jsx";
import TabBadges from "./TabBadges.jsx";
import { useClaimBadges } from "./claimBadgesContext.js";

// The ONE header style for every workspace tab: a compact h5 title (+ optional "?"
// business-rules help and small sub-text), actions right-aligned, underlined to
// match the Details tab's section labels. One slim row — screen real estate is
// premium (see docs/TODO.md conventions), so tabs never stack toolbars above this.
//
//   <TabHeader title="Orders" help="orders" actions={<>…buttons…</>} />
//
// Middle slot: the open claim's Needs-Attention chips (TabBadges), fed by
// ClaimBadgesContext so every tab gets them without prop-drilling. They fill the
// space between the title and the actions, collapsing to "+N" when it runs out
// (crowded Quotes header). Absent outside the claim workspace → nothing renders.
function TabHeader({ title, help = null, sub = null, actions = null, className = "" }) {
  const claimBadges = useClaimBadges();
  const hasBadges = !!claimBadges?.badges?.length;
  return (
    <div
      className={`tab-heading d-flex flex-wrap justify-content-between align-items-center gap-2 border-bottom pb-2 mb-3 ${className}`.trim()}
    >
      <div className="d-flex align-items-center gap-2 flex-shrink-0">
        <h5 className="mb-0">{title}</h5>
        {help ? <RulesHelp topic={help} /> : null}
        {sub ? <span className="small text-muted">{sub}</span> : null}
      </div>
      {hasBadges ? <TabBadges claimId={claimBadges.claimId} claimNumber={claimBadges.claimNumber} badges={claimBadges.badges} /> : null}
      {actions ? <div className="d-flex align-items-center gap-2 flex-wrap flex-shrink-0">{actions}</div> : null}
    </div>
  );
}

export default TabHeader;
